import { useGetUserQuery } from '@/slices/user'

export const useIsUserPwCMe = () => {
  const { data: user } = useGetUserQuery()
  return !!user?.rmc?.pwcMe
}
